<template>
    <div class="c-download">
        <LayoutContent>
            <div class="c-download-box">
                <div class="c-download-title">
                    <p class="text-space is-title">
                        <i class="gvfont gvfont-downloadicon"></i>
                        <span>{{ $t("main:SDK下载") }}</span>
                    </p>
                    <p class="text-space is-detail">{{ $t("main:最新版本号") }}V2.0.18</p>
                </div>
                <ul class="c-download-list">
                    <li class="list-item" v-for="item in downloadArr" :key="item.id">
                        <div :class="['cd-download-item ', item.color]">
                            <i :class="['item-bg-icon gvfont ', item.gvfont]"></i>
                            <div class="item-box is-content">
                                <p class="item-name">{{ item.title }}</p>
                            </div>
                            <div class="item-box" @click="handleDownload(item.url)">
                                <Button size="middle" type="transparent-dark">{{ $t("main:下 载") }}</Button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import Button from "@/components/UI/Button.vue";
import LayoutContent from "@/components/UI/LayoutContent.vue";
import { store } from "@ice/stark-data";

export default {
    name: "Download",
    components: { LayoutContent, Button },
    data() {
        return {
            downloadArr: [
                {
                    id: 0,
                    title: $t("main:安卓版本"),
                    color: "is-green",
                    gvfont: "gvfont-android",
                },
                {
                    id: 1,
                    title: $t("main:iOS版本"),
                    color: "is-grey",
                    gvfont: "gvfont-ios1",
                },
                {
                    id: 2,
                    title: "Win32 version",
                    color: "is-blue",
                    gvfont: "gvfont-windows-fill",
                },
                {
                    id: 3,
                    title: "UE4 version",
                    color: "is-purple",
                    gvfont: "gvfont-unrealengine",
                },
                {
                    id: 4,
                    title: "Unity version",
                    color: "is-purple",
                    gvfont: "gvfont-unity",
                },
                {
                    id: 5,
                    title: "Cocos version",
                    color: "is-cyan",
                    gvfont: "gvfont-cocos",
                },
                {
                    id: 6,
                    title: "Win64 version",
                    color: "is-blue",
                    gvfont: "gvfont-windows-fill",
                },
                {
                    id: 7,
                    title: "Wwise version",
                    color: "is-purple",
                    gvfont: "gvfont-wwise",
                },
            ],
        };
    },
    created() {
        const links = store.get("DOWNLOAD_CONFIG") || [];

        this.downloadArr = this.downloadArr.map((item) => {
            const data = links.find((link) => link.id === item.id);
            return {
                ...item,
                url: (data && data.url) || "",
            };
        });
    },
    methods: {
        handleDownload(url) {
            window.open(url);
        },
    },
};
</script>

<style scoped lang="less">
.c-download-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 600px;
    padding: 40px 0;
    position: relative;
    z-index: 22;
}
.c-download-list {
    display: flex;
    flex-wrap: wrap;
    margin: -20px -30px;
    position: relative;
    z-index: 2;
    .list-item {
        width: 33.333333%;
        padding: 20px 30px;
    }
}
.cd-download-item {
    display: flex;
    align-items: center;
    min-height: 100px;
    padding-left: 40px;
    padding-right: 24px;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    &.is-green {
        background-image: linear-gradient(-45deg, #1f9533, #32b16c);
        .c-button {
            background-color: #0c7b3d;
        }
        .gvfont {
            color: rgba(42, 150, 92, 0.5);
        }
    }
    &.is-grey {
        background-image: linear-gradient(-45deg, #7a7a7a, #b0b0b0);
        .c-button {
            background-color: #656565;
        }
        .gvfont {
            color: #8d8d8d;
        }
    }
    &.is-blue {
        background-image: linear-gradient(-45deg, #064c83, #1f7fcb);
        .c-button {
            background-color: #034982;
        }
        .gvfont {
            color: rgba(5, 96, 168, 0.5);
        }
    }
    &.is-purple {
        background-image: linear-gradient(-45deg, #243498, #5e79f8);
        .c-button {
            background-color: #1d2871;
        }
        .gvfont {
            color: rgba(54, 79, 192, 0.5);
        }
    }
    &.is-cyan {
        background-image: linear-gradient(-45deg, #32859c, #4ab2d0);
        .c-button {
            background-color: #267186;
        }
        .gvfont {
            color: rgba(22, 144, 179, 0.5);
        }
    }
    .item-box {
        height: 100%;
        &.is-content {
            flex: 1;
        }
        .item-name {
            line-height: 1;
            font-size: 20px;
            color: #fefeff;
            position: relative;
            z-index: 2;
        }
        .c-button {
            min-height: 36px;
            width: 100px;
            position: relative;
            z-index: 2;
            box-shadow: rgba(0, 0, 0, 0.2) 0 0 6px;
            &:hover {
                opacity: 0.7;
            }
        }
    }
    .item-bg-icon {
        position: absolute;
        top: -11px;
        left: -46px;
        &.gvfont {
            font-size: 180px;
        }
        &.gvfont-ios1 {
            left: -8px;
        }
        &.gvfont-windows-fill {
            left: -10px;
            top: -20px;
        }
        &.gvfont-unrealengine {
            top: -6px;
            left: 2px;
            font-size: 148px;
        }
        &.gvfont-unity {
            top: -4px;
            left: -14px;
            font-size: 150px;
        }
        &.gvfont-cocos {
            top: -12px;
            left: -12px;
            font-size: 156px;
        }
        &.gvfont-wwise {
            top: 0px;
            left: 0px;
            font-size: 114px;
        }
    }
}
.c-download {
    padding: 0 24px;
    position: relative;
    overflow: hidden;
    background-color: #151829;
    &::after {
        content: "";
        width: 100%;
        height: 214%;
        position: absolute;
        top: -2%;
        left: 0;
        background: radial-gradient(#172b71, rgba(255, 255, 255, 0) 67%, rgba(255, 255, 255, 0) 100%);
    }
}
.c-download-title {
    & + .c-download-list {
        margin-top: 40px;
    }
    .text-space {
        &.is-title {
            display: inline-flex;
            align-items: center;
            font-size: 28px;
            color: #fefeff;
            .gvfont {
                font-size: 28px;
                color: #999999;
                & + span {
                    margin-left: 12px;
                }
            }
        }
        &.is-detail {
            margin-left: 40px;
            font-size: 14px;
            color: #999999;
        }
        & + .text-space {
            margin-top: 8px;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-download-list {
        margin: -14px -18px;
        .list-item {
            padding: 14px 18px;
        }
    }
}
@media only screen and (max-width: 995px) {
    .c-download-list {
        margin: -10px -14px;
        .list-item {
            width: 50%;
            padding: 10px 14px;
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-download-list {
        margin: -10px 0;
        .list-item {
            width: 100%;
            padding: 10px 0;
        }
    }
    .c-download-title {
        & + .c-download-list {
            margin-top: 24px;
        }
        .text-space {
            &.is-title {
                font-size: 24px;
                .gvfont {
                    font-size: 24px;
                    & + span {
                        margin-left: 8px;
                    }
                }
            }
            &.is-detail {
                margin-left: 32px;
            }
        }
    }
}
</style>
